import ReviewsConstants from 'app/shared/constants/ReviewsConstants';

const Review = ({
    reviewIdAsString = '',
    starLevel = 0,
    reviewMessage = '',
    brand = '',
    reviewType = '',
    reviewStatus = '',
    createdIsoString = '',
    responseMessage = '',
    reviewResponseStatus = '',
    reviewResponseDateIsoString = '',
    reviewResponseIdAsString = '',
    managerReportedStatus = '',
} = {}) => ({
    id: String(reviewIdAsString),
    starLevel: Number(starLevel),
    reviewMessage: String(reviewMessage),
    brand: String(brand.toLowerCase()),
    reviewType: String(ReviewsConstants.REVIEW_TYPES[reviewType]),
    reviewStatus: String(ReviewsConstants.REVIEW_STATUS[reviewStatus]),
    createdIsoString: String(createdIsoString),
    responseMessage: reviewResponseStatus === ReviewsConstants.RESPONSE_STATUS.DELETED
        ? '' : String(responseMessage),
    reviewResponseStatus: String(reviewResponseStatus),
    reviewResponseDateIsoString: String(reviewResponseDateIsoString),
    reviewResponseId: String(reviewResponseIdAsString),
    managerReportedStatus: String(managerReportedStatus),
});

export default Review;
